export default "__VITE_ASSET__DyCmlCwK__"